import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import OTPLogin from "./OTPLogin";

export default function Login() {
  const { user, loading, googleLogin } = useAuth();
  const navigate = useNavigate();
  const [useOTP, setUseOTP] = useState(false); // toggle between OTP / Google

  // ✅ Determine where to redirect after login
  const redirectAfterLogin = sessionStorage.getItem("redirectAfterLogin") || "/home";

  // ✅ Redirect if already logged in
  useEffect(() => {
    if (!loading && user) {
      navigate(redirectAfterLogin, { replace: true });
      sessionStorage.removeItem("redirectAfterLogin"); // clear after use
    }
  }, [user, loading, navigate, redirectAfterLogin]);

  // ✅ Detect real-time auth changes (e.g., OTP success or Google sign-in)
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        navigate(redirectAfterLogin, { replace: true });
        sessionStorage.removeItem("redirectAfterLogin");
      }
    });
    return () => unsubscribe();
  }, [navigate, redirectAfterLogin]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "100px 20px" }}>
        <h3>Loading...</h3>
      </div>
    );
  }

  return (
    <div
      style={{
        textAlign: "center",
        padding: "80px 20px",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <img
        src="/eyal-logo.png"
        alt="Eyal App"
        style={{ width: "90px", marginBottom: "20px" }}
      />

      {!useOTP ? (
        <>
          <h2
            style={{
              fontSize: "26px",
              fontWeight: "700",
              marginBottom: "25px",
              color: "#222",
            }}
          >
            Welcome to Eyal App
          </h2>

          {/* ✅ OTP Login First */}
          <button
            onClick={() => setUseOTP(true)}
            style={{
              background: "#25D366",
              color: "white",
              border: "none",
              padding: "10px 24px",
              borderRadius: "10px",
              cursor: "pointer",
              fontSize: "15px",
              fontWeight: "500",
            }}
          >
            Login with OTP
          </button>
{/*
          <p
            style={{
              margin: "25px 0 15px",
              color: "#666",
              fontSize: "14px",
            }}
          >
            — or —
          </p>

           ✅ Google Sign-in Second 
          <button
            onClick={async () => {
              await googleLogin(navigate);
              navigate(redirectAfterLogin, { replace: true });
              sessionStorage.removeItem("redirectAfterLogin");
            }}
            style={{
              background: "#007bff",
              color: "white",
              border: "none",
              padding: "12px 28px",
              borderRadius: "10px",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "500",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            Sign in with Google
          </button>
          */}
        </>
      ) : (
        <>
          {/* OTP Login Component */}
          <OTPLogin />

          {/* Back button */}
          <button
            onClick={() => setUseOTP(false)}
            style={{
              marginTop: "20px",
              background: "transparent",
              color: "#007bff",
              border: "none",
              cursor: "pointer",
              fontSize: "15px",
              textDecoration: "underline",
            }}
          >
            ← Back to  Login
          </button>
        </>
      )}
    </div>
  );
}
